import "./UnsupportedDevice.css";
import unsupportedDeviceFallBack from "../../Assets/unsupportedDeviceFallBack.svg";

export default function UnsupportedDevice(props) {
  return (
    <div className="inherit-parent-height display-flex  flex-direction-column flex-justify-content-space-between">
      <div className="display-flex flex-justify-content-center text-align-center inherit-parent-width inherit-parent-height padding-left-larger padding-right-larger unsupported-device-body">
        <div className="display-flex flex-direction-column flex-justify-content-center">
          <img
            src={unsupportedDeviceFallBack}
            alt="unsupportedDeviceFallBack"
            className="unsupported-device-fallback-image max-height-250px"
          />
        </div>

        <div className="display-flex flex-justify-content-center flex-direction-column align-items-center  flex-align-items-center padding-left-larger padding-right-larger unsupported-device-content-area">
          <div className="font-family-gilroy-regular unsupported-device-primary-content-web">
            This device is not supported
          </div>

          <div className="font-family-gilroy-regular unsupported-device-primary-content-phone">
            Web browser is not supported
          </div>

          <div className="padding-top-medium font-size-large unsupported-device-secondary-content-web">
            Please use Desktop web browser
          </div>

          <div className="padding-top-medium font-size-large unsupported-device-secondary-content-phone">
            Please use Desktop web browser
          </div>
        </div>
      </div>
    </div>
  );
}
